import dcmjs from 'dcmjs';

export default function naturalizeDataset(instance) {
  return dcmjs.data.DicomMetaDictionary.naturalizeDataset(instance);
}
